import React from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';

export interface CropAreaData {
  id: string;
  blob: Blob;
  pageIndex: number;
  cropArea: {
    x: number;
    y: number;
    width: number;
    height: number;
  };
  previewUrl: string;
}

interface CropAreaProps {
  crop: CropAreaData;
  onDelete: (id: string) => void;
}

export const CropArea = ({ crop, onDelete }: CropAreaProps) => {
  return (
    <div className="relative bg-card border border-border rounded-lg p-2 group">
      <img
        src={crop.previewUrl}
        alt={`Crop ${crop.id}`}
        className="w-full h-16 object-cover rounded"
      />
      <Button
        variant="destructive"
        size="sm"
        className="absolute -top-2 -right-2 w-6 h-6 p-0 opacity-0 group-hover:opacity-100 transition-opacity"
        onClick={() => onDelete(crop.id)}
      >
        <X className="w-3 h-3" />
      </Button>
      <div className="text-xs text-muted-foreground mt-1">
        Page {crop.pageIndex + 1}
      </div>
    </div>
  );
};